import { FC } from 'react';
import Alert from '@mui/material/Alert';
import styles from 'shared/alert-message/alert-message.module.css';

interface IAlertMessage {
  message?: string;
  severity?: string;
}
interface IAlertProps {
  alertInfo: IAlertMessage;
}
export const AlertMessage: FC<IAlertProps> = (props) => {
  return (
    <Alert className={
      props.alertInfo.severity === "error" ?
        `${styles.alert} ${styles.alertError}` :
        `${styles.alert} ${styles.alertSuccess}`
    }
      severity={props.alertInfo.severity === "error" ? "error" : "success"}
    >
      {props.alertInfo.message}
    </Alert>
  );
}
